import {
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  FunctionField,
  useRecordContext
} from 'react-admin';
import { Grid, Box } from '@mui/material';
import { BackButton } from '../../../helperComponents/BackButton';
import { StatusChip } from './components/StatusChip';
import { JsonBlock } from './components/JsonBlock';
import { ApproveButton } from './components/ApproveButton';
import { RejectButton } from './components/RejectButton';

const AdsActionsShowBody = () => {
  const record = useRecordContext();
  if (!record) return null;

  return (
    <>
      <SimpleShowLayout>
        <TextField source="id" label="ID" />
        <TextField source="account_name" label="Account Name" />
        <TextField source="industry_id" label="Industry ID" />
        <TextField source="entity_type" label="Entity Type" />
        <TextField source="entity_id" label="Entity ID" />
        <TextField source="action" label="Action" />
        <TextField source="reason" label="Reason" />
        <TextField source="proposed_by" label="Proposed By" />
        <DateField source="proposed_at" label="Proposed At" showTime />
        <FunctionField label="Status" render={(row) => <StatusChip status={row.status} />} />
        <TextField source="approved_by" label="Approved By" />
        <DateField source="approved_at" label="Approved At" showTime />
        <DateField source="expires_at" label="Expires At" showTime />
        <TextField source="rejected_by" label="Rejected By" />
        <DateField source="rejected_at" label="Rejected At" showTime />
        <TextField source="reject_reason" label="Reject Reason" />
        <DateField source="picked_at" label="Picked At" showTime />
        <TextField source="picked_run_id" label="Picked Run ID" />
        <TextField source="pick_count" label="Pick Count" />
        <DateField source="executed_at" label="Executed At" showTime />
        <TextField source="error" label="Error" />
      </SimpleShowLayout>
      <Grid container spacing={2} sx={{ px: 2 }}>
        <Grid item xs={12} md={4}>
          <JsonBlock title="Params" value={record.params} />
        </Grid>
        <Grid item xs={12} md={4}>
          <JsonBlock title="Expected before" value={record.expected_before} />
        </Grid>
        <Grid item xs={12} md={4}>
          <JsonBlock title="Value after" value={record.value_after} />
        </Grid>
      </Grid>
      <Box sx={{ display: 'flex', gap: 2, p: 2 }}>
        <ApproveButton />
        <RejectButton />
      </Box>
    </>
  );
};

export const AdsActionsShow = (props) => {
  return (
    <>
      <BackButton path="/ads_actions" />
      <span className="h4">Action Approval</span>
      <Show {...props} title=" ">
        <AdsActionsShowBody />
      </Show>
    </>
  );
};
